import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownCruiseContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownCruiseContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownCruiseContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownCruiseContracts/${id}`, request)
}

export {get, post, put, patch}
